import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, GoogleAuthProvider, signInWithPopup } from "../Firebase/firebaseConfig";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as fbSignOut,
  onAuthStateChanged,
  updateProfile,
} from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser({
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          phone: user.phoneNumber || "",
        });
      } else setCurrentUser(null);
    });
    return unsub;
  }, []);

  const signInWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
    const res = await signInWithPopup(auth, provider);
    const user = res.user;
    setCurrentUser({
      uid: user.uid,
      email: user.email,
      name: user.displayName,
      phone: user.phoneNumber || "",
    });
    return user;
  } catch (e) {
    console.error(e);
    throw e;
  }
  };

  const signUpWithEmail = async (email, password, displayName) => {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    if (displayName) {
      await updateProfile(res.user, { displayName });
    }
    setCurrentUser({
      uid: res.user.uid,
      email: res.user.email,
      name: displayName || res.user.displayName,
      phone: res.user.phoneNumber || "",
    });
    return res.user;
  };

  const signInWithEmail = async (email, password) => {
    const res = await signInWithEmailAndPassword(auth, email, password);
    setCurrentUser({
      uid: res.user.uid,
      email: res.user.email,
      name: res.user.displayName,
      phone: res.user.phoneNumber || "",
    });
    return res.user;
  };

  const signOut = async () => {
    await fbSignOut(auth);
    setCurrentUser(null);
  };

  return (
    <AuthContext.Provider value={{ currentUser, signInWithGoogle, signUpWithEmail, signInWithEmail, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
